// db.ts
import Dexie, { Table } from "dexie";
import api from "../config/api";

export interface IndexDBProduct {
  id: number;
  productId?: number;
  productCode?: string;
  batchNumber?: number;
  productName?: string;
  modelNumber?: string;
  hsnCode?: string;
  gst?: number;
  igst?: number;
  cgst?: number;
  sgst?: number;
  expiryDate?: string;
  pwoGst?: number;
  pwGst?: number;
  wholesaleRate?: number;
  retailRate?: number;
  mrp?: number;
  stock?: number;
  department?: string;
  category?: string;
  brand?: string;
  updatedByOn?: string;
}

export class MyDatabase extends Dexie {
  products!: Table<IndexDBProduct, number | string>;

  constructor() {
    super('point_of_sale');
    this.version(1).stores({
      products: 'id, productId, productName, productCode, batchNumber, modelNumber, sac, gst, productDetails, pwoGst, pwGst, wholesaleRate, retailRate, mrp, stock, department, category, brand, vendor, updatedByOn, hsnCode'
    });
  }
}

const db = new MyDatabase();

export async function refreshProductsFromAPI() {
  try {
    const response = await api().get("/product/productSearch/?search=");
    const data = response.data?.data ?? [];

    if (data.length > 0) {
      await db.products.clear();
      await db.products.bulkPut(data);
      console.log("Dexie: products refreshed from API");
    }
  } catch (error) {
    console.error("Failed to refresh products:", error);
  }
}

export default db;
